import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";
import Toggle from "components/Toggle/Toggle";
import ToggleNavigation from "components/Toggle/ToggleNavigation";
import {black400, black500, greyishBlue100, greyishBlue200} from "assets/jss/main";

import {ENRICHMENT_STATES} from "../enrichmentConstants";

StateSelector.propTypes = {
    value: PropTypes.oneOf(ENRICHMENT_STATES).isRequired,
    counts: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

function StateSelector({value, counts, onChange}) {
    return (
        <ToggleNavigation value={ENRICHMENT_STATES.indexOf(value)} onChange={(index) => onChange(ENRICHMENT_STATES[index])}>
            {ENRICHMENT_STATES.map((state) => {
                const active = state === value;

                return (
                    <Toggle
                        key={state}
                        round={false}
                        noWrapText
                        style={{
                            gap: '8px',
                            background: active ? '#fff' : 'transparent',
                            border: `1px solid ${active ? greyishBlue200 : 'transparent'}`,
                            color: active ? black500 : black400,
                        }}
                        label={
                            <span style={{display: 'inline-flex', alignItems: 'center', gap: '8px'}}>
                                <FormattedMessage id={`enrichment.state.${state}`}/>
                                <Badge
                                    backgroundColor={active ? black500 : greyishBlue100}
                                    labelColor={active ? '#fff' : black400}
                                >
                                    {counts[state] ?? 0}
                                </Badge>
                            </span>
                        }
                    />
                );
            })}
        </ToggleNavigation>
    );
}

export default StateSelector;
